<template>
<div>
  <e-chart ref="chart" @initialized="onChartInitialized" />
</div>
</template>

<script>
import EChart from '../../../../../components/Charts/ECharts'
export default {
  name: 'FactorSourcePie',
  components: {EChart},
  props: {
    sourceNameConfigs: {
      required: true,
      type: Array
    },
    dataMap: {
      required: true,
      type: Object
    },
    dataTime: {
      required: true
    },
    dataTimeFormatter: {
      required: true,
      type: String
    }
  },
  computed: {
    newDataMap () {
      const {dataMap, dataTimeFormatter} = this
      return Object.keys(dataMap).reduce((map, dataTime) => {
        map[new Date(dataTime).format(dataTimeFormatter)] = dataMap[dataTime]
        return map
      }, {})
    }
  },
  methods: {
    renderChart () {
      const {dataTime} = this
      let data = this.newDataMap[dataTime]

      if (data) {
        const {sourceNameConfigs} = this
        const chartOpt = {
          title: {
            text: dataTime,
            left: 'center'
          },
          toolbox: {
            feature: {
              saveAsImage: {}
            },
            right: 10
          },
          tooltip: {
            trigger: 'item',
            appendToBody: true
          },
          color: sourceNameConfigs.map(sourceNameConfig => sourceNameConfig.color),
          series: [{
            name: dataTime,
            type: 'pie',
            // radius: '100px',
            // startAngle: 0,
            label: {
              show: true,
              position: 'inside',
              formatter: '{b}:{d}%',
              color: '#000000'
            },
            data: sourceNameConfigs.map(sourceNameConfig => ({
              name: sourceNameConfig.name,
              value: data[sourceNameConfig.id]
            }))
          }]
        }

        this.$refs.chart.setOpt(chartOpt, true)
      } else {
        this.$refs.chart.clear()
      }
    },
    onChartInitialized () {
      this.renderChart()
    }
  },
  watch: {
    dataTime () {
      this.renderChart()
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/04Statistical-Analysis/11PMF-Analysis/01PM/01Run/FactorSourcePie.vue